/* eslint-disable react/no-array-index-key */
import React from "react";
import { cls } from "@wss/cls";
import { connect } from "react-redux";
import { PlusLink } from "@clarkinc/zest-design-system/ui";
import formatAsCurrency from "@wss/utilities/formatAsCurrency";
import { RootState, UserState } from "~/common/Store/models/RootReadonly";
import isNonExclusiveForPlatinumPlusProduct from "~/productListing/ProductBox/isNonExclusivePlatinumPlusProduct";
import Stars from "~/common/Stars";
import AddToCart from "./CarouselAddToCart";
import { CarouselItem } from "./CarouselItem";
import NoScriptLazyImage from "~/common/NoScriptLazyImage";
import CarouselPlatinumPlusExclusive from "./CarouselPlatinumPlusExclusive";
import SaleBadgeAndPricing from "~/common/SaleBadgeAndPricing";
import { onClickCtrTrack } from "~/analytics/ClickThroughRateTracking/clickThroughRateHelpers";
interface Props {
  item: CarouselItem;
  user: UserState;
  showAddToCart: boolean;
  addToCartFormId?: string;
  activeSalePricingClassNames?: string;
  containsQuantityDropdown?: boolean;
  setContainsQuantityDropdown?: (value: boolean) => void;
  addCarouselItemToCart?: (itemNumber: string, quantity: string, accessories?: string) => void;
  isCartCarousel?: boolean;
  carouselName?: string;
  originalLinkingItemNumber?: string;
}
const CarouselMember = ({
  item,
  user,
  showAddToCart,
  addToCartFormId = "",
  containsQuantityDropdown,
  setContainsQuantityDropdown,
  addCarouselItemToCart,
  activeSalePricingClassNames = "",
  isCartCarousel = false,
  carouselName,
  originalLinkingItemNumber
}: Props) => {
  let styleObj = {};
  if (showAddToCart && containsQuantityDropdown) {
    styleObj = {
      bottom: "104px",
      left: "36px"
    };
  }
  const plusRibbon = <div className="ribbon-stack">
      <a href="/plus/" className="ribbon ribbon--mini ribbon--plus" style={{
      visibility: item.isWebstaurantPlusEligible ? "visible" : "hidden"
    }}>
        <span className="ribbon__text">plus</span>
      </a>
    </div>;
  const image = <div className="product-image">
      <a href={item.link} className="image companionItemClicked" title={item.description} data-label={item.feedIdentifier} data-action="click" onClick={() => onClickCtrTrack(carouselName, originalLinkingItemNumber)}>
        <NoScriptLazyImage alt={item.description} src={item.imagePath} width={1} height={1} />
      </a>
    </div>;
  const itemPrice = <div className={cls("pricing", "text-center", showAddToCart && containsQuantityDropdown ? "absolute" : "", "p-0", activeSalePricingClassNames)} data-component="Pricing" style={styleObj}>
      {item.displaySalePrice ? <SaleBadgeAndPricing price={item.price} salePricingClassNames={cls("carousel-sale-price")} saleBadgeExtraClassNames={cls("mr-1", "mt-0.5", "px-3/4", "py-[1px]")} /> : null}
      <p className="price">
        {item.displaySalePrice ? formatAsCurrency.formatIfUndefined(item.salePrice) : formatAsCurrency.formatIfUndefined(item.price)}
        {item.unitOfMeasure && <span className="each">{`/${item.unitOfMeasure}`}</span>}
      </p>
    </div>;
  const productDescription = <a href={item.link} className={cls("description", "companionItemClicked", "m-0", "p-0")} title={item.description} data-label={item.feedIdentifier} data-action="click" onClick={() => onClickCtrTrack(carouselName, originalLinkingItemNumber)}>
      {item.description}
    </a>;
  const addToCartProduct = {
    ...item
  };
  const {
    minimumBuy,
    mustBuy
  } = item;
  if (minimumBuy > 1 || mustBuy > 1) {
    setContainsQuantityDropdown?.(true);
  }
  const addToCartItem = <li className="ag-item gap-2" data-item-number={item.itemNumber} gtm-tracking-number={item.itemNumber}>
      {image}
      <div className={`details ${isCartCarousel ? "flex flex-col gap-2" : ""}`}>
        <div className="mt-1/2 align-middle">{plusRibbon}</div>
        {productDescription}
      </div>
      {item.price > 0 && itemPrice}
      <CarouselPlatinumPlusExclusive user={user} customerExclusivity={item.customerExclusivity} />
      {isNonExclusiveForPlatinumPlusProduct(item.customerExclusivity, user) && <AddToCart useSingleItemStyle={false} formId={addToCartFormId} product={addToCartProduct} userEmail={user?.emailAddress} addCarouselItemToCart={addCarouselItemToCart} containsQuantityDropdown={containsQuantityDropdown} carouselName={carouselName} originalLinkingItemNumber={originalLinkingItemNumber} />}
    </li>;
  const starsItem = <li className="ag-item gtm-item" data-item-number={item.itemNumber} gtm-tracking-number={item.itemNumber}>
      {image}
      <div className={cls("details", cls("flex", "flex-col", "gap-2", "mt-[5px]"))}>
        <div className={cls("flex", "justify-center")}>
          {item.isWebstaurantPlusEligible ? <PlusLink className="inline-flex mx-1" iconProps={{
          "data-testid": "plus-badge-icon-new"
        }} /> : <div className="ribbon-stack">&nbsp;</div>}
          <Stars rating={item.overallRating} />
        </div>
        {productDescription}
        {itemPrice}
      </div>
    </li>;
  const categoryItem = <li className="ag-item">
      <div className="details mt-0">
        <a href={item.link} data-target="title" className="product-image text-sm font-semibold category_name" title={item.description}>
          <NoScriptLazyImage className="product-image mb-1-1/2" style={{
          width: "105px"
        }} src={item.imagePath} alt="" />
          <p className="h-11 mt-2" style={{
          lineHeight: "15px",
          fontSize: "13.2px"
        }}>
            {item.description}
          </p>
        </a>
        <div className="pricing" data-component="Pricing">
          <p className="product-count">
            {item.categoryItemCount} {item.categoryItemDescription}
          </p>
        </div>
      </div>
    </li>;
  if (item.isCategory) {
    return categoryItem;
  }
  if (showAddToCart) {
    return addToCartItem;
  }
  return starsItem;
};
export const mapStateToProps = (state: RootState) => ({
  user: state.user
});
export default connect(mapStateToProps)(CarouselMember);